var Register = function() {

    var register = function(data) {
        Ajax.register(data, function(res) {
            if (res.success == 'ok') {
                window.location.href = '/affiliates';
                return;
            }
            // failed
            $('#register_btn').prop('disabled', false);
            switch (res.reason) {
            case 'username':
                UserDataValidation.showUsernameErrorPrompts('server');
                break;
            case 'pwd':
                UserDataValidation.showPasswordErrorPrompt('invalid');
                break;
            case 'domain':
                $('#domain_container').addClass('error');
                break;
            default:
                alert('Η δημιουργία προφίλ απέτυχε');
                break;
            }
        });
    };

    return {
        init: function() {
            UserDataValidation.init();

            $('#password, #password_again').on('input blur', function() {
                UserDataValidation.hidePasswordPrompts();
                UserDataValidation.checkPwd($(this).val());
            });

            $('#register_btn').click(function() {
                // user ignored username error prompt
                if ($('#username_container').hasClass('error')) {
                    return;
                }
                // hide prompts
                UserDataValidation.hideUsernameErrorPrompts();
                UserDataValidation.hidePasswordPrompts();

                var data = {
                    username: $('#username').val(),
                    password: $('#password').val(),
                    domain: $('#domain').val()
                };

                if (!UserDataValidation.checkPwd(data['password'])) {
                    return;
                }
                if (!data['domain']) {
                    $('#domain_container').addClass('error');
                    return;
                }

                $('#register_btn').prop('disabled', true);

                // another username check before register(), in case the user
                // clicked 'save' with #username still in focus
                Ajax.checkUsername(data['username'], function(res) {
                    if (res.success != 'ok') {
                        $('#register_btn').prop('disabled', false);
                        UserDataValidation.showUsernameErrorPrompts(res.reason);
                        return;
                    }
                    register(data);
                });
            });
        }
    };
}();
